import { Link, useNavigate } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { InstagramIcon } from "./InstagramIcon";
import { company, services } from "../data/site";

export const Footer = () => {
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  return (
    <footer className="noise-overlay bg-[#0B1528] text-slate-400">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-white p-1">
              <img src="/assets/logo-icon.png" alt="STARLINK Security & Facilities logo" className="h-full w-full object-contain" />
            </span>
            <span className="font-serif text-lg font-bold text-white">{company.name}</span>
          </div>
          <p className="text-sm leading-relaxed">
            STARLINK Security Force is a premier provider of integrated security and facility
            solutions, dedicated to protecting what matters most—your people, property, and peace
            of mind.
          </p>
          <div className="flex items-center gap-4 mt-6">
            <a href={company.instagram} aria-label="Instagram" data-testid="footer-instagram-link"
              className="text-slate-400 hover:text-sky-400 transition-colors duration-200">
              <InstagramIcon className="h-5 w-5" />
            </a>
          </div>
        </div>

        <div data-testid="footer-quick-links">
          <h4 className="font-mono text-xs tracking-[0.2em] uppercase text-slate-500 mb-5">Quick Links</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="hover:text-sky-400 transition-colors" data-testid="footer-home-link">Home</Link></li>
            <li><Link to="/clients" className="hover:text-sky-400 transition-colors" data-testid="footer-clients-link">Clients</Link></li>
            <li><Link to="/gallery" className="hover:text-sky-400 transition-colors" data-testid="footer-gallery-link">Gallery</Link></li>
            <li><Link to="/about" className="hover:text-sky-400 transition-colors" data-testid="footer-about-link">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-sky-400 transition-colors" data-testid="footer-contact-link">Contact Us</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-mono text-xs tracking-[0.2em] uppercase text-slate-500 mb-5">Services</h4>
          <ul className="space-y-3 text-sm">
            {services.map((s) => (
              <li key={s.id}>
                <button
                  onClick={() => navigate(`/services/${s.id}`)}
                  className="hover:text-sky-400 transition-colors"
                  data-testid={`footer-service-${s.id}-link`}
                >
                  {s.title}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-mono text-xs tracking-[0.2em] uppercase text-slate-500 mb-5">Contact</h4>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3">
              <Phone className="h-4 w-4 mt-0.5 text-sky-500 shrink-0" />
              <span data-testid="footer-phone">{company.phone}<br />{company.phone2}</span>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="h-4 w-4 mt-0.5 text-sky-500 shrink-0" />
              <span data-testid="footer-email">{company.email}</span>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="h-4 w-4 mt-0.5 text-sky-500 shrink-0" />
              <span data-testid="footer-address">{company.address}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500" data-testid="footer-copyright">
            © {year} {company.legalName}. All rights reserved.
          </p>
          <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-slate-600">
            Precision Facility Infrastructure
          </p>
        </div>
      </div>
    </footer>
  );
};
